import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpload from "components/shared/ImageUpload";
import removeImg from "assets/svgs/close.svg";

const WhyItem = ({ item, index, onRemove, onChange }) => {
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: item.image || "",
  });

  const handleChange = (field, value) => {
    if (field === "image" && selectedImage.path) {
      onChange(index, { ...item, image: selectedImage.path });
    } else {
      onChange(index, { ...item, [field]: value });
    }
  };

  return (
    <div className="add-multi-component">
      <button
        type="button"
        onClick={() => onRemove(index)}
        className="removeImg"
        aria-label="Remove service"
      >
        <img src={removeImg} alt="Remove service" />
      </button>
      <Row>
        <Col lg={12}>
          <ImageUpload
            selectedImage={selectedImage}
            setSelectedImage={(newImage) => {
              setSelectedImage(newImage);
              if (newImage.path) {
                handleChange("image", newImage.path);
              }
            }}
            defaultImage={item.image || ""}
            label={<FormattedMessage id="image" />}
          />
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="title" /> ({" "}
              <FormattedMessage id="arabic-language" /> )
            </h5>
            <input
              type="text"
              className="form-control"
              value={item.title?.ar || ""}
              onChange={(e) =>
                handleChange("title", { ...item.title, ar: e.target.value })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="title" /> ({" "}
              <FormattedMessage id="english-language" /> )
            </h5>
            <input
              type="text"
              className="form-control"
              value={item.title?.en || ""}
              onChange={(e) =>
                handleChange("title", { ...item.title, en: e.target.value })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="description" /> ({" "}
              <FormattedMessage id="arabic-language" /> )
            </h5>
            <textarea
              className="form-control"
              value={item.description?.ar || ""}
              onChange={(e) =>
                handleChange("description", {
                  ...item.description,
                  ar: e.target.value,
                })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="description" /> ({" "}
              <FormattedMessage id="english-language" /> )
            </h5>
            <textarea
              className="form-control"
              value={item.description?.en || ""}
              onChange={(e) =>
                handleChange("description", {
                  ...item.description,
                  en: e.target.value,
                })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default WhyItem;
